import { render } from "./StudentDiscountListView.vue?vue&type=template&id=f7d69f8e&scoped=true"
import script from "./StudentDiscountListView.vue?vue&type=script&lang=js"
export * from "./StudentDiscountListView.vue?vue&type=script&lang=js"

import "./StudentDiscountListView.vue?vue&type=style&index=0&id=f7d69f8e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7d69f8e"]])

export default __exports__